import Logger from '../../tools/Logger';

const log = Logger.child({ component: 'Error' });

function BaseError(name = 'BaseError', message, fileName, lineNumber) {
  const instance = new Error(message, fileName, lineNumber);
  instance.name = name;
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, BaseError);
  }

  log.error(`${name}: ${message}`);

  return instance;
}

BaseError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true,
  },
});

Object.setPrototypeOf(BaseError, Error);

export default BaseError;
